'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UploadDropzone = require('./UploadDropzone');

var _UploadDropzone2 = _interopRequireDefault(_UploadDropzone);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var UploadDropzoneContainer = function (_Component) {
  _inherits(UploadDropzoneContainer, _Component);

  function UploadDropzoneContainer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UploadDropzoneContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UploadDropzoneContainer.__proto__ || Object.getPrototypeOf(UploadDropzoneContainer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      files: [],
      isUploading: false,
      isSuccess: false,
      error: ''
    }, _this.prepareFormData = function (fileIndex) {
      var files = _this.state.files;
      var fileFieldName = _this.props.fileFieldName;
      var formData = new FormData();
      var currentFile = files[fileIndex] || null;

      if (currentFile) {
        formData.append(fileFieldName, currentFile.file, currentFile.title);
      }

      return formData;
    }, _this.handleUploadFiles = function () {
      var files = _this.state.files;
      Promise.all(files.map(function (file, index) {
        return new Promise(function (resolve) {
          return _this.handleUploadRequest({
            index: index,
            resolve: resolve
          });
        });
      })).then(function (uploads) {
        _this.handleUploadDone(uploads);
      });
    }, _this.handleUploadRequest = function (_ref2) {
      var index = _ref2.index,
          resolve = _ref2.resolve;
      var _this$props = _this.props,
          endpoint = _this$props.endpoint,
          headers = _this$props.headers,
          transformUploadedResponse = _this$props.transformUploadedResponse;

      var form = _this.prepareFormData(index);

      var req = new XMLHttpRequest();
      req.open('POST', endpoint);
      req.setRequestHeader('Accept', 'application/json');
      Object.keys(headers).forEach(function (headerKey) {
        req.setRequestHeader(headerKey, headers[headerKey]);
      });
      req.withCredentials = false;
      req.addEventListener('load', function (e) {
        if (req.status >= 200 && req.status <= 299) {
          resolve(transformUploadedResponse(req.response));
        } else {
          _this.handleUploadFailure({
            index: index,
            error: req.response || 'Error with sending!'
          });
        }
      }, false);
      req.addEventListener('error', function (e) {
        _this.handleUploadFailure({
          index: index,
          error: 'Error with sending!'
        });
      }, false);
      req.upload && req.upload.addEventListener('progress', function (e) {
        var progress = 0;

        if (e.total !== 0) {
          progress = parseInt(e.loaded / e.total * 100, 10);
        }

        _this.handleUploadProgress({
          index: index,
          progress: progress
        });
      }, false);
      req.addEventListener('abort', function (e) {
        _this.handleUploadProgress({
          index: index,
          progress: 0
        });
      }, false);
      req.send(form);
    }, _this.handleRemove = function () {
      _this.setState({
        isUploading: false,
        isSuccess: false,
        files: []
      });
    }, _this.handleUploadDone = function (urls) {
      var files = _this.state.files;
      var handleUploadSuccess = _this.props.handleUploadSuccess;

      _this.setState({
        files: files.map(function (file, index) {
          return _extends({}, file, {
            url: urls[index],
            progress: 100
          });
        }),
        isUploading: false,
        isSuccess: true,
        error: ''
      }, function () {
        return handleUploadSuccess && handleUploadSuccess(_this.state);
      });
    }, _this.handleUploadFailure = function (_ref3) {
      var index = _ref3.index,
          error = _ref3.error;
      var handleUploadFailure = _this.props.handleUploadFailure;
      var files = [].concat(_toConsumableArray(_this.state.files));

      if (!files[index]) {
        return;
      }

      files[index].error = error || 'Error with sending!';

      _this.setState({
        isUploading: false,
        isSuccess: false,
        files: files
      }, function () {
        return handleUploadFailure && handleUploadFailure(_this.state);
      });
    }, _this.handleUploadProgress = function (_ref4) {
      var index = _ref4.index,
          progress = _ref4.progress;
      var handleUploadProgress = _this.props.handleUploadProgress;
      var files = [].concat(_toConsumableArray(_this.state.files));

      if (!files[index]) {
        return;
      }

      files[index].progress = progress;

      _this.setState({
        files: files
      }, function () {
        return handleUploadProgress && handleUploadProgress(_this.state);
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UploadDropzoneContainer, [{
    key: 'handleUpload',
    value: function handleUpload(addedFiles, rejectedFiles) {
      var _this2 = this;

      var handleUploadReject = this.props.handleUploadReject;

      if (addedFiles && addedFiles.length > 0) {
        this.setState({
          files: addedFiles.map(function (file) {
            return {
              title: file.name,
              file: file,
              progress: 0,
              error: null
            };
          }),
          isUploading: true
        }, function () {
          return _this2.handleUploadFiles();
        });
      }

      if (rejectedFiles && rejectedFiles.length > 0) {
        this.setState({
          files: [],
          isUploading: false,
          isSuccess: false,
          error: 'File(s) ' + rejectedFiles.map(function (file) {
            return file.name;
          }).join(', ') + ' is too big or has wrong extension!'
        }, function () {
          return handleUploadReject && handleUploadReject(_this2.state);
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_UploadDropzone2.default, _extends({}, this.props, this.state, {
        handleUpload: this.handleUpload.bind(this),
        handleRemove: this.handleRemove.bind(this)
      }));
    }
  }]);

  return UploadDropzoneContainer;
}(_react.Component);

UploadDropzoneContainer.defaultProps = {
  endpoint: '/file/upload',
  headers: {},
  fileFieldName: 'file',
  maxSizeMb: 50,
  isMultipleFiles: false,
  acceptFiles: 'image/jpeg,image/png',
  isPlaceholder: true,
  transformUploadedResponse: function transformUploadedResponse(response) {
    try {
      response = JSON.parse(response);
      return response.data ? response.data : null;
    } catch (exception) {
      return null;
    }
  }
};
exports.default = UploadDropzoneContainer;
module.exports = exports.default;